import {
  rangeLabel,
  resolvePlayer,
  resolveStats,
  upcomingFixtures
} from './block-helpers';
import { HeadToHeadCard } from './HeadToHeadCard';
import {
  buildComparisonRows,
  DEFAULT_STAT_MODE
} from '@lib/article-blocks/stats';
import type {
  ArticleBlockData,
  SanityHeadToHeadBlock
} from '@lib/article-blocks/types';

type HeadToHeadBlockProps = {
  value: SanityHeadToHeadBlock;
  data: ArticleBlockData;
};

export const HeadToHeadBlock = ({ value, data }: HeadToHeadBlockProps) => {
  const playerOne = resolvePlayer(data, value.playerOne);
  const playerTwo = resolvePlayer(data, value.playerTwo);
  if (!playerOne || !playerTwo) return null;

  const statsFor = (optaUuid: string) =>
    resolveStats(data, value.venue, value.gameweekRange, optaUuid);

  return (
    <HeadToHeadCard
      playerOne={playerOne}
      playerTwo={playerTwo}
      rows={buildComparisonRows(
        statsFor(playerOne.externalIds.optaUuid),
        statsFor(playerTwo.externalIds.optaUuid),
        value.statMode ?? DEFAULT_STAT_MODE
      )}
      rangeLabel={rangeLabel(value.gameweekRange, data.currentGameweek)}
      upcomingOne={upcomingFixtures(data, playerOne.team.shortName)}
      upcomingTwo={upcomingFixtures(data, playerTwo.team.shortName)}
    />
  );
};
